<template>
    <div>
        <section class="content-header">
            <h1>
                Реферальная система
            </h1>
        </section>

        <section class="content container-fluid">
            <div class="row">
                <div class="col-md-5">
                    <div class="box">
                        <div class="box-header">
                            <h3 class="box-title">Информация</h3>
                        </div>
                        <div class="box-body">
                            <p>Привлекайте рефералов по ссылке и зарабатывайте <b>{{ $store.getters['user/getUser'].ref_percent }}%</b> от расходов вашего реферала.
                                Средства поступят на основной баланс, который можно будет вывести на на wmr, яд или киви.
                                Выплаты производятся до двух дней.</p>
                            <div class="form-group">
                                <label>Ссылка для приглашения</label>
                                <div class="input-group">
                                    <input :value="$store.getters['user/getUser'].ref_link" class="el-input__inner" readonly>
                                    <span class="input-group-btn pl-3">
                                        <el-button type="primary" @click="copyRef()" icon="el-icon-copy-document"></el-button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7">
                    <NativeTable action="user/getReferral">
                        <el-table-column prop="0" label="id" min-width="180" sortable="custom">
                            <template slot-scope="scope">
                                {{ scope.row.id }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="0" label="Логин" min-width="180" sortable="custom">
                            <template slot-scope="scope">
                                {{ scope.row.login }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="2" label="Доход" sortable="custom" min-width="120px">
                            <template slot-scope="scope">
                                {{ scope.row.sum }} <i class="fa fa-ruble"></i>
                            </template>
                        </el-table-column>

                        <template slot="mobile-card" slot-scope="scope">
                            <div class="media">
                                <div class="media-body">
                                    <h4 class="media-heading">{{ scope.row.login }}</h4>
                                    <p class="m-0">{{ scope.row.sum }} <i class="fa fa-ruble"></i></p>
                                </div>
                            </div>
                        </template>

                    </NativeTable>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: "Money",
        data() {
            return {
                refLink: this.$store.getters['user/getUser'].ref_link
            }
        },
        methods: {
            copyRef() {
                this.$clipboard(this.$store.getters['user/getUser'].ref_link)
                this.$notify({
                    title: 'Отлично',
                    message: 'Ссылка успешно скопирована',
                    type: 'success'
                });
            }
        },
    }
</script>

<style scoped>

</style>
